import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../supabase';

export default function Login() {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { login, user } = useAuth();
  const successMessage = location.state?.message || '';

  useEffect(() => {
    if (user) {
      navigate('/profile');
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      let email;
      const isEmail = identifier.includes('@');

      if (isEmail) {
        email = identifier;
      } else {
        // try to find an email for this phone in the users table
        const { data: byPhone, error: byPhoneError } = await supabase
          .from('users')
          .select('email')
          .eq('telefono', identifier)
          .maybeSingle();

        if (byPhoneError) throw new Error(byPhoneError.message);

        if (byPhone?.email) {
          email = byPhone.email;
        } else {
          // try alternate column name
          const { data: byPhone2, error: byPhoneError2 } = await supabase
            .from('users')
            .select('email')
            .eq('phone', identifier)
            .maybeSingle();

          if (byPhoneError2) throw new Error(byPhoneError2.message);
          email = byPhone2?.email;
        }

        if (!email) {
          setError('Non hai ancora un account. Registrati!');
          return;
        }
      }

      // Authenticate with Supabase
      const { data: authData, error: authError } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (authError) {
        const raw = authError.message || '';
        const italian = /invalid login credentials/i.test(raw)
          ? 'Credenziali non valide!'
          : raw || 'Credenziali non valide!';
        setError(italian);
        return;
      }

      // try to load the user's profile from the `users` table
      const userId = authData?.user?.id;
      let profile = null;

      if (userId) {
        const { data: profileData } = await supabase
          .from('users')
          .select('*')
          .eq('auth_id', userId)
          .maybeSingle();
        profile = profileData || null;
      }

      if (!profile) {
        const { data: profileByEmail } = await supabase
          .from('users')
          .select('*')
          .eq('email', email)
          .maybeSingle();
        profile = profileByEmail || null;
      }

      const savedData = {
        nome: profile?.first_name || profile?.nome || '',
        cognome: profile?.last_name || profile?.cognome || '',
        email: authData.user?.email || email,
        telefono: profile?.phone || profile?.telefono || '',
        // Support both English and Italian column names from DB
        loyalty_points:
          profile?.loyalty_points ?? profile?.punti_fedelta ?? 0,
      };

      login(savedData);
      alert('Accesso effettuato!');
      navigate('/profile');
    } catch (err) {
      setError(err.message || 'Errore durante il login.');
    }
  };

  return (
    <div className="form-container">
      <h2 className="yellow title">Accedi</h2>
      {successMessage && <p className="success-message">{successMessage}</p>}
      <form onSubmit={handleLogin}>
        <label>Email o Telefono:</label>
        <input
          type="text"
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          required
        />
        <label>Password:</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <p className="error-message">{error}</p>}
        <button type="submit">Accedi</button>
      </form>
      <p>
        Non hai un account?{' '}
        <Link to="/registration" className="link">
          Registrati
        </Link>
      </p>
    </div>
  );
}